<!--
  -    Copyright (c) 2018-2025, lengleng All rights reserved.
  -
  - Redistribution and use in source and binary forms, with or without
  - modification, are permitted provided that the following conditions are met:
  -
  - Redistributions of source code must retain the above copyright notice,
  - this list of conditions and the following disclaimer.
  - Redistributions in binary form must reproduce the above copyright
  - notice, this list of conditions and the following disclaimer in the
  - documentation and/or other materials provided with the distribution.
  - Neither the name of the pig4cloud.com developer nor the names of its
  - contributors may be used to endorse or promote products derived from
  - this software without specific prior written permission.
  - Author: lengleng (wangiegie@gmail.com)
  -->
<template>
	<div class="execution">
		<basic-container>
			<avue-crud
				ref="crud"
				:before-open="onHandleBeforeOpen"
				:data="tableData"
				:option="tableOption"
				:page.sync="page"
				:permission="permissionList"
				:table-loading="tableLoading"
				@on-load="getList"
				@search-change="searchChange"
				@refresh-change="refreshChange"
				@size-change="sizeChange"
				@current-change="currentChange"
				@row-update="handleUpdate"
				@row-save="handleSave"
				@row-del="rowDel" />
		</basic-container>
	</div>
</template>

<script>
import {addObj, delObj, fetchList, putObj} from '@/api/admin/sys-public-param'
import {tableOption} from '@/const/crud/admin/sys-public-param'
import {mapGetters} from 'vuex'

export default {
	name: 'Syspublicparam',
	data() {
		return {
			searchForm: {},
			tableData: [],
			page: {
				total: 0, // 总页数
				currentPage: 1, // 当前页数
				pageSize: 20, // 每页显示多少条
			},
			tableLoading: false,
			tableOption: tableOption,
		}
	},
	computed: {
		...mapGetters(['permissions']),
		permissionList() {
			return {
				addBtn: this.vaildData(this.permissions.admin_syspublicparam_add, false),
				delBtn: this.vaildData(this.permissions.admin_syspublicparam_del, false),
				editBtn: this.vaildData(this.permissions.admin_syspublicparam_edit, false),
			}
		},
	},
	methods: {
		getList(page, params) {
			this.tableLoading = true
			fetchList(
				Object.assign(
					{
						descs: 'create_time',
						current: page.currentPage,
						size: page.pageSize,
					},
					params,
					this.searchForm,
				),
			).then((response) => {
				this.tableData = response.data.data.records
				this.page.total = response.data.data.total
				this.tableLoading = false
			})
		},
		rowDel: function (row, index) {
			this.$confirm('是否确认删除ID为' + row.publicId, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(function () {
					return delObj(row.publicId)
				})
				.then((data) => {
					this.getList(this.page)
					this.$message.success('删除成功')
					this.getList(this.page)
				})
		},
		onHandleBeforeOpen(show, type) {
			window.boxType = type
			show()
		},
		/**
		 * @title 数据更新
		 * @param row 为当前的数据
		 * @param index 为当前更新数据的行数
		 * @param done 为表单关闭函数
		 *
		 **/
		handleUpdate: function (row, index, done, loading) {
			putObj(row)
				.then((data) => {
					this.$message.success('修改成功')
					done()
					this.getList(this.page)
				})
				.catch(() => {
					loading()
				})
		},
		/**
		 * @title 数据添加
		 * @param row 为当前的数据
		 * @param done 为表单关闭函数
		 *
		 **/
		handleSave: function (row, done, loading) {
			addObj(row)
				.then((data) => {
					this.$message.success('添加成功')
					done()
					this.getList(this.page)
				})
				.catch(() => {
					loading()
				})
		},
		searchChange(form, done) {
			this.searchForm = form
			this.page.currentPage = 1
			this.getList(this.page, form)
			done()
		},
		refreshChange() {
			this.getList(this.page)
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize
		},
		currentChange(current) {
			this.page.currentPage = current
		},
	},
}
</script>
